import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, BookOpen, NotebookPen, MessageCircle, Phone } from "lucide-react";
import { toast } from "sonner";
import InquiryModal from "@/components/InquiryModal";
import { hasSalesIQ } from "@/lib/analytics";

const TEL = "tel:+919015887887";

export default function MobileBottomNav() {
  const { pathname } = useLocation();
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [chatEnabled, setChatEnabled] = useState(hasSalesIQ());

  useEffect(() => {
    const onReady = () => setChatEnabled(hasSalesIQ());
    window.addEventListener("tb:track-ready", onReady);
    return () => window.removeEventListener("tb:track-ready", onReady);
  }, []);

  const isHome = pathname === "/";
  const isCourses = pathname.startsWith("/courses") || pathname.startsWith("/programs") || pathname.startsWith("/domains");

  const item = "flex flex-col items-center justify-center gap-1 min-w-[60px] min-h-[56px] rounded-2xl px-3 py-1.5 transition-colors";
  const active = "bg-[#FFC72C] text-[#17263B]";
  const inactive = "text-[#17263B] active:bg-slate-100";

  const openChat = () => {
    const siq = window.$zoho && window.$zoho.salesiq;
    if (siq && siq.floatwindow && siq.floatwindow.visible) {
      try { siq.floatwindow.visible("show"); return; } catch (e) {}
    }
    toast.info("Connecting you to chat…");
    setTimeout(() => {
      try { window.$zoho?.salesiq?.floatwindow?.visible("show"); } catch (e) {}
    }, 1500);
  };

  return (
    <>
      <nav
        className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white border-t border-slate-100 shadow-[0_-8px_30px_rgba(15,23,42,0.12)] rounded-t-3xl"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        data-testid="mobile-bottom-nav"
        aria-label="Mobile quick navigation"
      >
        <div className={`grid ${chatEnabled ? "grid-cols-5" : "grid-cols-4"} items-end px-3 pt-2 pb-2`}>
          <Link to="/" className={`${item} ${isHome ? active : inactive}`} data-testid="mobile-nav-home" aria-label="Home">
            <Home className="w-6 h-6" strokeWidth={isHome ? 2.4 : 1.9} />
            <span className="text-[11px] font-bold">Home</span>
          </Link>
          <Link to="/courses" className={`${item} ${isCourses ? active : inactive}`} data-testid="mobile-nav-courses" aria-label="Courses">
            <BookOpen className="w-6 h-6" strokeWidth={isCourses ? 2.4 : 1.9} />
            <span className="text-[11px] font-bold">Courses</span>
          </Link>
          <button type="button" onClick={() => setEnquiryOpen(true)} className={`${item} ${enquiryOpen ? active : inactive}`} data-testid="mobile-nav-enquiry" aria-label="Enquiry">
            <NotebookPen className="w-6 h-6" strokeWidth={enquiryOpen ? 2.4 : 1.9} />
            <span className="text-[11px] font-bold">Enquiry</span>
          </button>
          {chatEnabled && (
            <button type="button" onClick={openChat} className={`${item} ${inactive}`} data-testid="mobile-nav-chat" aria-label="Chat with us">
              <MessageCircle className="w-6 h-6" strokeWidth={1.9} />
              <span className="text-[11px] font-bold">Chat</span>
            </button>
          )}
          <a href={TEL} className={`${item} ${inactive}`} data-testid="mobile-nav-call" aria-label="Call Training Basket">
            <Phone className="w-6 h-6" strokeWidth={1.9} />
            <span className="text-[11px] font-bold">Call</span>
          </a>
        </div>
      </nav>
      <InquiryModal open={enquiryOpen} onOpenChange={setEnquiryOpen} />
    </>
  );
}
